module.exports = __webpack_public_path__ + "img/jingyilin.b45ee7a1.jpg";